export const StrategyBackground = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1440"
    height="581"
    viewBox="0 0 1440 581"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.5" filter="url(#filter0_f_7097_169617)">
      <path
        d="M674.468 199.008C735.462 213.799 860.782 117.926 920.24 64.3362C923.291 61.5863 926.688 59.3983 930.594 58.1271C1081.79 8.91423 1442.05 226.505 1417.84 344.329C1393.31 463.682 412.053 474.668 429.963 417.738C447.872 360.809 37.8972 380.784 25.4383 344.329C12.9795 307.874 84.618 287.399 118.491 261.431C152.363 235.463 369.615 272.417 424.512 199.008C479.409 125.598 596.211 180.031 674.468 199.008Z"
        fill="#161616"
      />
      <path
        d="M674.468 199.008C735.462 213.799 860.782 117.926 920.24 64.3362C923.291 61.5863 926.688 59.3983 930.594 58.1271C1081.79 8.91423 1442.05 226.505 1417.84 344.329C1393.31 463.682 412.053 474.668 429.963 417.738C447.872 360.809 37.8972 380.784 25.4383 344.329C12.9795 307.874 84.618 287.399 118.491 261.431C152.363 235.463 369.615 272.417 424.512 199.008C479.409 125.598 596.211 180.031 674.468 199.008Z"
        fill="url(#paint0_radial_7097_169617)"
        fillOpacity="0.18"
      />
      <path
        d="M674.468 199.008C735.462 213.799 860.782 117.926 920.24 64.3362C923.291 61.5863 926.688 59.3983 930.594 58.1271C1081.79 8.91423 1442.05 226.505 1417.84 344.329C1393.31 463.682 412.053 474.668 429.963 417.738C447.872 360.809 37.8972 380.784 25.4383 344.329C12.9795 307.874 84.618 287.399 118.491 261.431C152.363 235.463 369.615 272.417 424.512 199.008C479.409 125.598 596.211 180.031 674.468 199.008Z"
        fill="url(#paint1_radial_7097_169617)"
        fillOpacity="0.18"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7097_169617"
        x="-105.6"
        y="-78.6"
        width="1654.2"
        height="659.2"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="64.8" result="effect1_foregroundBlur_7097_169617" />
      </filter>
      <radialGradient
        id="paint0_radial_7097_169617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(516.295 11.7713) rotate(90) scale(408.258 907.67)"
      >
        <stop stopColor="#A8E5FF" />
        <stop offset="1" stopColor="#A8E5FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_7097_169617"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(516.295 655.297) rotate(-90) scale(442.856 984.591)"
      >
        <stop stopColor="#4C8AFF" />
        <stop offset="1" stopColor="#4C8AFF" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
